<template>
    <v-row :style="`margin:auto;max-width:400px;border:1px solid ${color}`" class="pa-10" :class="{'ma-5':isXsDevice}" no-gutters justify="center" align="center">
        <v-col align="center" cols="12">
        <h3 style="line-height: 4.125rem;" :class="fontHeading" v-html="text"></h3>
        </v-col>
        <v-col cols="12" align="center"><v-btn class="mt-8 mb-5" depressed outlined :color="color" tile :to="to" >{{buttonText}}</v-btn></v-col>
    </v-row>
</template>

<script>
import {layoutMixin} from '@/utils/layout-mixin'
    export default {
        mixins: [layoutMixin],
        components:{
        },
        props:{
            color:{
                type:String,
                default:'black'
            },
            text:{
                type:String,
                default:"Los geht's.<br/> Projekt starten"
            },
            buttonText:{
                type:String,
                default:"jetzt kontaktieren"
            },
            to:{
                type:String,
                default:"/kontakt"
            }

        },
        computed:{
            sectionHeight(){
                return this.bgHeight-(0.3*this.bgHeight);
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>